module.exports = __webpack_public_path__ + "assets/img/floater.e40dad7c.png";